export default {
  baseURL: "https://ushoutai.truelovecity.com", // 美国空降刷单-正式环境
};
